export default __webpack_public_path__ + "static/media/delivery_truck_speed.8012c44b.svg";